import { DirectionalLight, HemisphericLight, Light, SpotLight } from '@babylonjs/core/Lights';
import { StandardMaterial } from '@babylonjs/core/Materials/standardMaterial';
import { Color3 } from '@babylonjs/core/Maths/math';
import { CylinderBuilder } from '@babylonjs/core/Meshes/Builders/cylinderBuilder';
import { GroundBuilder } from '@babylonjs/core/Meshes/Builders/groundBuilder';
import { SphereBuilder } from '@babylonjs/core/Meshes/Builders/sphereBuilder';
import { Mesh } from '@babylonjs/core/Meshes/mesh';
import { Scene } from '@babylonjs/core/scene';

export function createLightVisualization(light: Light, scene: Scene, color?: Color3) {
    let lightPositionGizmo: Mesh;

    if (!color) {
        color = Color3.Yellow();
    }

    if (light instanceof HemisphericLight) {
        lightPositionGizmo = SphereBuilder.CreateSphere(
            'lightPositionMarker',
            { diameter: 0.75, slice: 0.5, segments: 6 },
            scene
        );
        const coloredMaterial = new StandardMaterial('', scene);
        coloredMaterial.wireframe = true;
        coloredMaterial.emissiveColor = color;
        lightPositionGizmo.material = coloredMaterial;
    } else if (light instanceof SpotLight) {
        lightPositionGizmo = CylinderBuilder.CreateCylinder(
            'lightPositionCone',
            { diameterTop: 0.5, height: 0.5, diameterBottom: 0, tessellation: 12 },
            scene
        );
        lightPositionGizmo.position.y = 0.25;
        lightPositionGizmo.bakeCurrentTransformIntoVertices();

        const coloredMaterial = new StandardMaterial('', scene);
        coloredMaterial.wireframe = true;
        coloredMaterial.emissiveColor = color;
        lightPositionGizmo.material = coloredMaterial;
    } else if (light instanceof DirectionalLight) {
        const gizmoOffset = 1;
        lightPositionGizmo = GroundBuilder.CreateGround(
            'lightPositionPlane',
            {
                height: 1.5,
                width: 1.5,
                subdivisions: 1,
            },
            scene
        );
        const cone = CylinderBuilder.CreateCylinder(
            'cylinder',
            { diameterTop: 0, height: 0.075, diameterBottom: 0.0375, tessellation: 96 },
            scene
        );
        const line = CylinderBuilder.CreateCylinder(
            'cylinder',
            { diameterTop: 0.005, height: 0.5, diameterBottom: 0.005, tessellation: 96 },
            scene
        );

        const coloredMaterial = new StandardMaterial('', scene);
        coloredMaterial.wireframe = true;
        coloredMaterial.emissiveColor = color;

        lightPositionGizmo.material = coloredMaterial;
        cone.material = coloredMaterial;
        line.material = coloredMaterial;
        //cone.rotation.x = Math.PI / 2;
        lightPositionGizmo.position.y = -gizmoOffset;
        lightPositionGizmo.bakeCurrentTransformIntoVertices();

        cone.parent = lightPositionGizmo;
        line.parent = lightPositionGizmo;
        cone.position.y = 0.275 - gizmoOffset;
        line.position.y = -gizmoOffset;
        //line.rotation.x = Math.PI / 2;
    } else {
        // PointLight
        lightPositionGizmo = SphereBuilder.CreateSphere('lightPositionMarker', { diameter: 0.1 }, scene);
        const coloredMaterial = new StandardMaterial('', scene);
        coloredMaterial.emissiveColor = color;
        lightPositionGizmo.material = coloredMaterial;
    }

    lightPositionGizmo.isPickable = false;
    lightPositionGizmo.setEnabled(true);
    return lightPositionGizmo;
}
